<template>
  <t-span>{{rounded}} {{currency}}</t-span>
</template>

<script>

import formatter from '../helper/formatter'
export default {
  props: {
    value: [Number, Object],
    currency: String
  },

  computed: {
    precision() {
      if (this.currency === 'JPY') return 0
      else return 2
    },

    rounded() {
      return this.currency
              ? formatter.usNumberFormat(this.value, this.precision)
              : this.value
    }
  }
}

</script>



// WEBPACK FOOTER //
// src/core/charts/components/money.vue